import * as t from 'io-ts';
import { AccountNotificationDynamicType } from './accountNotification';

export const AccountNotificationsListDynamicType = t.array(AccountNotificationDynamicType);

export type AccountNotificationsList = t.TypeOf<typeof AccountNotificationsListDynamicType>;
